export default __webpack_public_path__ + "static/ab1-5959983b178bba148bcb7e5e967bcc62.png";